import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAdminIcon, LazyAdminIconOnline } from '#components'
const lazyGlobalComponents = [
  ["AdminIcon", LazyAdminIcon],
["AdminIconOnline", LazyAdminIconOnline],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
